import { FooterContext } from "@contexts/FooterContext";
import React, { useContext } from "react";

const SecurityIcons = () => {
  const { securityIcons } = useContext(FooterContext);

  return (
    <div className="grid grid-cols-[auto_auto_auto] items-center gap-10 md:justify-center md:gap-[33.33px] md:pb-6 sm:gap-6 sm:pb-4">
      {securityIcons?.map((item, key) => {
        const isLastItem = key === securityIcons?.length - 1;

        return (
          <a
            key={key}
            href={
              item?.imageLink?.page?.value?.data?.url || item?.imageLink?.url
            }
            className={`${
              isLastItem ? "sm:col-span-1 sm:justify-self-center" : ""
            }`}
          >
            <img src={item?.image} alt={item?.imageAltText} />
          </a>
        );
      })}
    </div>
  );
};

export default SecurityIcons;
